import { redirect } from '@tanstack/react-router'

/**
 * Throws a TanStack Router redirect to `/home`. Call as the safe fallback when a
 * stored/intended redirect target is missing or untrusted — `/home` is the one
 * safe landing spot every authenticated user can reach.
 */
export const redirectHome = () => {
	throw redirect({ to: '/home' })
}
